module.exports = __webpack_public_path__ + "media/apps/mitch-android-5-c8c8ed83.png";